export const MAX_SIZE_20_MB = 20_000_000;
